import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { fetchRelatedJobs } from "./RelatedJobsAPI"
const initialState = {
    data: [],
    loading: false,
    error: null,
};

export const getRelatedJobs = createAsyncThunk(
    "jobs/fetchRelatedJobs",
    async (uuid, { rejectWithValue }) => {
        try {
            const response = await fetchRelatedJobs(uuid);
            return response?.response; // Return the whole response array
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const jobSlice = createSlice({
    name: "jobs",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getRelatedJobs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getRelatedJobs.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload
                state.error = null;

            })
            .addCase(getRelatedJobs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
    },
})

// Selector
export const selectJobState = (state) => state.jobs.data

export default jobSlice.reducer